import React, { useState } from 'react';
import { ArrowLeft, CheckCircle2, Share2, Scroll, Feather } from 'lucide-react';
import { useInventory } from '../hooks/useInventory';
interface PullListProps {
  onBack: () => void;
}
export function PullList({
  onBack
}: PullListProps) {
  const {
    getShoppingList
  } = useInventory();
  const shoppingList = getShoppingList();
  const [checkedItems, setCheckedItems] = useState<Set<string>>(new Set());
  const toggleItem = (id: string) => {
    const newChecked = new Set(checkedItems);
    if (newChecked.has(id)) {
      newChecked.delete(id);
    } else {
      newChecked.add(id);
    }
    setCheckedItems(newChecked);
  };
  const uncheckedCount = shoppingList.length - checkedItems.size;
  // Group by category
  const groupedList = shoppingList.reduce((acc, item) => {
    if (!acc[item.category]) acc[item.category] = [];
    acc[item.category].push(item);
    return acc;
  }, {} as Record<string, typeof shoppingList>);
  return <div className="pb-24 max-w-md mx-auto p-4 min-h-screen" data-id="element-466">
      <div className="flex items-center justify-between mb-6" data-id="element-467">
        <div className="flex items-center" data-id="element-468">
          <button onClick={onBack} className="mr-3 p-2 hover:bg-[#C9A227]/20 rounded-full transition-colors" data-id="element-469">
            <ArrowLeft className="w-5 h-5 text-[#722F37]" data-id="element-470" />
          </button>
          <div data-id="element-471">
            <h1 className="text-xl font-cinzel font-bold text-[#2C2C2C]" data-id="element-472">
              Requisition Scroll
            </h1>
            <p className="text-sm text-[#722F37] font-serif italic" data-id="element-473">
              {uncheckedCount} items required
            </p>
          </div>
        </div>
        <button className="p-2 hover:bg-[#C9A227]/20 rounded-full transition-colors" data-id="element-474">
          <Share2 className="w-5 h-5 text-[#722F37]" data-id="element-475" />
        </button>
      </div>

      {shoppingList.length === 0 ? <div className="flex flex-col items-center justify-center py-20 text-center" data-id="element-476">
          <div className="w-20 h-20 bg-[#F5F0E1] border-2 border-[#C9A227] rounded-full flex items-center justify-center mb-4 shadow-[0_0_15px_rgba(201,162,39,0.2)]" data-id="element-477">
            <CheckCircle2 className="w-10 h-10 text-[#2D5A3D]" data-id="element-478" />
          </div>
          <h2 className="text-xl font-cinzel font-bold text-[#2C2C2C]" data-id="element-479">
            Stores Replenished!
          </h2>
          <p className="text-[#722F37] mt-2 font-serif italic" data-id="element-480">
            No requisitions needed at this time
          </p>
        </div> : <div className="space-y-6" data-id="element-481">
          {Object.entries(groupedList).map(([category, items]) => <div key={category} className="bg-[#FFFDF5] rounded-xl border border-[#C9A227]/40 overflow-hidden shadow-sm relative" data-id="element-482">
              {/* Parchment top edge effect */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#C9A227]/20 via-[#C9A227]/40 to-[#C9A227]/20" data-id="element-483" />

              <div className="px-4 py-3 bg-[#F5F0E1] border-b border-[#C9A227]/20 flex items-center gap-2" data-id="element-484">
                <div className="w-1.5 h-1.5 rounded-full bg-[#722F37]" data-id="element-485" />
                <h2 className="font-cinzel font-bold text-[#722F37] text-sm tracking-wide" data-id="element-486">
                  {category}
                </h2>
              </div>

              <div className="divide-y divide-[#C9A227]/10" data-id="element-487">
                {items.map(item => {
            const isChecked = checkedItems.has(item.id);
            return <div key={item.id} onClick={() => toggleItem(item.id)} className={`flex items-center p-4 cursor-pointer transition-all ${isChecked ? 'bg-[#F5F0E1]/50' : 'hover:bg-[#F5F0E1]'}`} data-id="element-488">
                      <div className={`w-6 h-6 rounded-md border-2 mr-3 flex items-center justify-center transition-all ${isChecked ? 'bg-[#2D5A3D] border-[#2D5A3D]' : 'border-[#C9A227] bg-[#FFFDF5]'}`} data-id="element-489">
                        {isChecked && <Feather className="w-3.5 h-3.5 text-[#F5F0E1]" data-id="element-490" />}
                      </div>

                      <div className="flex-1" data-id="element-491">
                        <div className={`font-serif font-medium ${isChecked ? 'line-through text-[#2C2C2C]/40 decoration-[#722F37]/40' : 'text-[#2C2C2C]'}`} data-id="element-492">
                          {item.name}
                        </div>
                        <div className="text-xs text-[#555] font-serif italic" data-id="element-493">
                          {item.zone} • Need {item.suggestedQuantity}{' '}
                          {item.unit}
                        </div>
                      </div>

                      <span className={`text-[10px] font-bold px-2 py-1 rounded-full border ${item.priority === 'High' ? 'bg-[#8B0000]/10 text-[#8B0000] border-[#8B0000]/20' : item.priority === 'Medium' ? 'bg-[#D4A017]/10 text-[#D4A017] border-[#D4A017]/20' : 'bg-[#2D5A3D]/10 text-[#2D5A3D] border-[#2D5A3D]/20'}`} data-id="element-494">
                        {item.priority === 'High' ? 'Urgent' : item.priority === 'Medium' ? 'Soon' : 'Low'}
                      </span>
                    </div>;
          })}
              </div>
            </div>)}
        </div>}

      {shoppingList.length > 0 && <div className="fixed bottom-20 left-0 right-0 px-4 max-w-md mx-auto z-40" data-id="element-495">
          <button className="w-full bg-[#722F37] text-[#F5F0E1] p-4 rounded-xl font-cinzel font-bold shadow-[0_4px_12px_rgba(114,47,55,0.4)] flex items-center justify-center gap-2 active:scale-[0.98] transition-transform border-2 border-[#C9A227] hover:bg-[#8B3A44]" data-id="element-496">
            <Scroll className="w-5 h-5" data-id="element-497" />
            {checkedItems.size > 0 ? `Mark ${checkedItems.size} as Acquired` : 'Begin Requisition'}
          </button>
        </div>}
    </div>;
}